import { FooterNavItem } from '@/components/nav/footer';
import { Flex } from '@mantine/core';
import { IconHomeBolt, IconLayoutGridAdd, IconShoppingCart, IconTrophy } from '@tabler/icons-react';
import styles from './styles.module.css';

export type BottomNavProps = {
	nav: 'home';
};

export const BottomNav = () => {
	return (
		<Flex w="100%" className={styles.root} gap="lg" align="center" justify="center">
			<FooterNavItem to="/home" label="Home" icon={IconHomeBolt} />
			<FooterNavItem to="/scan-bag" label="Scan" icon={IconLayoutGridAdd} />
			<FooterNavItem to="/rewards" label="Rewards" icon={IconTrophy} />
			<FooterNavItem to="/shop" label="Order" icon={IconShoppingCart} />
		</Flex>
	);
};
